const SIGN_UP_EXPERIMENT_ID = "";

export { SIGN_UP_EXPERIMENT_ID };
